export const SPECIALIST = "SPECIALIST"
export const OTHER = "OTHER"



// WEBPACK FOOTER //
// ./assets/search/constants.js